module.exports = __webpack_public_path__ + "static/media/grin-squint-tears.bf6c953a.svg";